<div class="layout-container">
  <app-sidebar></app-sidebar>
</div>
